export default __webpack_public_path__ + "static/montserrat-v14-latin-600-562baba2a88edacbe520b88554ca3f11.ttf";